<template>
  <div>
    <maritimeService
      :name="heading"
      subProps="Marine industry software designed to streamline operations and improve efficiency"
    />
    <v-container>
      <v-row>
        <v-col sm="12" md="7" lg="7" class="mt-sm-20">
          <br />
          <v-img
            src="@/assets/Maritech-Mail.jpg"
            class="mx-auto"
            width="200px;"
          />
          <div class="pt-3">
            <div>
              At Maritech IT Solutions, we embark on a transformative journey to
              enhance communication and streamline operations for seafarers
              worldwide.
              <br /><br />
              A secure email solution you can rely on, equipped with features
              tailored to meet all the mail needs of vessels and crew in the
              business.
              <br /><br />
              A crew email address is an email address that includes your
              company's domain name (for
              example,<b>name@crew.companyname.com</b>). Using a branded
              business email address helps to establish credibility, build
              trust, and promote your brand.
            </div>
            
            <br />
            <div>
              <strong>Why Choose Maritech IT Solutions:</strong>
              <ul>
                <li>
                  <strong>Seafarer-Centric Approach:</strong> Tailored
                  exclusively for maritime professionals, our solution provides
                  seafarers with robust and reliable email addresses to stay
                  connected with ease, wherever their voyage takes them.
                </li>
                <li>
                  <strong>Efficiency and Automation:</strong> Beyond email
                  provisioning, we empower you to automate workflows and
                  processes based on email address creation, ensuring smoother
                  operations and heightened productivity.
                </li>
                <li>
                  <strong>Cost-Effective Solution:</strong> We understand the
                  importance of budget-conscious solutions in the maritime
                  industry. Our offering strikes the perfect balance between
                  affordability and top-tier functionality.
                </li>
                <li>
                  <strong>Technical Support:</strong> Our dedicated team is at
                  your service, providing expert assistance and guidance
                  whenever you need it.
                </li>
              </ul>
            </div>
          </div>
          <v-row class="pt-3">
            <v-col v-for="(feature, i) in features" :key="i" cols="12" md="12">
              <base-avatar-card v-bind="feature" align="left" horizontal />
            </v-col>
          </v-row>

          <div>
            <br />
            <strong>Contact Us Today</strong>
            <br />
            Ready to set sail on a voyage of technological excellence? Reach out
            to us at<a href="mailto:info@maritechsoftware.com"
              >info@maritechsoftware.com</a
            >
            to learn more about our innovative solutions and how we can empower
            your maritime ventures. <br /><br />
            Navigate the seas of success with Maritech IT Solutions - where
            cutting-edge technology meets maritime expertise.
          </div>
        </v-col>
        <v-col sm="12" md="5" lg="5"> <base-request /> </v-col>
      </v-row>
    </v-container>

    <div class="text-center pt-5">
      <strong>
        "A one-size-fits-all approach is not effective for either shoes or
        software. Both need to be tailored to the individual user or business to
        be truly effective."</strong
      >
    </div>
  </div>
</template>

<script>
import maritimeService from "../../components/maritime-service.vue";
export default {
  components: {
    maritimeService
  },

  data: () => ({ heading: "" }),
  mounted() {
    this.heading = "mMail: Smart Maritech Mail - Reliable, Secure, Affordable";
  },

  data: () => ({
    features: [
      {
        color: "blue darken-2",
        dark: true,
        title: "Unlimited Crew Mailboxes",
        icon: "mdi-mailbox-outline",
        text: "Ensure seamless communication onboard with unlimited crew mailboxes offered by mMail. Every member can have their dedicated email space, optimizing communication efficiency and connectivity across the vessel without limitations."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "AI-Assisted Email Writing and Composing",
        icon: "mdi-robot",
        text: "Experience enhanced efficiency in email communication with mMail's AI-assisted writing and composing feature. Streamline the email creation process with intelligent suggestions and automation, ensuring clear and effective communication."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Powered by Secure Amazon Cloud Technology",
        icon: "mdi-cloud-outline",
        text: "mMail leverages the robust and secure infrastructure of Amazon Cloud Technology, providing a reliable and fortified platform for your email solution. Rest assured that your communication data is safeguarded and accessible with top-notch security measures in place."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Advanced Malware and AV Scanning",
        icon: "mdi-bug",
        text: "Utilizing state-of-the-art multiple scanning engines operating across various time zones, ensuring all incoming attachments are scanned before reaching the vessel, aiming to minimize infections and potentially eliminate them entirely"
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Dedicated Mobile App with Company Branding",
        icon: "mdi-cellphone",
        text: "Empower your crew with a dedicated mobile app, customized with your company branding, through mMail. Keep your team connected while reinforcing your brand identity, allowing access to essential communication tools anytime, anywhere."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Effortless Web Portal Control",
        icon: "mdi-web",
        text: "Empowering shipowners to create mailboxes and configure inbound and outbound email restrictions, the web portal simplifies email settings management for vessels."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Flexible Licensing",
        icon: "mdi-arrow-decision",
        text: "We employ flexible licensing models; our vessel-based licensing starts at $10 USD per vessel and is not dependent on the number of crews."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Free Backup for All Incoming and Outgoing Emails",
        icon: "mdi-email-sync-outline",
        text: "Offering an additional security layer for peace of mind, this feature comes at no extra cost."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Free ITSM/ERP System Integration",
        icon: "mdi-cogs",
        text: "mMail offers seamless integration with ITSM/ERP systems at no additional cost, streamlining operations and enhancing efficiency."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Reliability",
        icon: "mdi-shield-check-outline",
        text: "With a guaranteed 99.9% uptime, financially-backed service level agreement, you can count on your email always being up and running."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Easy to maintain",
        icon: "mdi-cog-outline",
        text: "It's easier than ever to provide your users with the business email they need to stay productive. Automatic patching eliminates the time and effort of maintaining your system."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "In-place archive",
        icon: "mdi-archive-arrow-down-outline",
        text: "Give your users an in-place archive, so they can keep all their important data in one place."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Access from anywhere",
        icon: "mdi-check-circle-outline",
        text: "Provide your users with anywhere access to email, calendar, and contacts on all major browsers and across devices."
      },
      {
        color: "blue darken-2",
        dark: true,
        title: "Threat Intelligence powered by SophosLabs",
        icon: "mdi-security",
        text: "Enhance your security with Threat Intelligence powered by SophosLabs, offering robust virus scanning for attachments and uploaded files. Safeguard your system against potential threats with advanced protection backed by cutting-edge technology."
      }
    ]
  })
};
</script>

<style scoped>
p {
  text-align: justify;
}
.rowclr {
  background-color: rgb(239, 239, 239);
}
.mt-sm-20 {
  text-align: justify;
}
h2 {
  font-size: 35px;
}
h1 {
  font-size: 30px;
  color: rgb(3, 50, 97);
}

@media (max-width: 960px) {
  .mt-sm-20 {
    margin-top: 150px;
    padding: 25px;
  }
}

@media (max-width: 800px) {
  .mt-sm-20 {
    margin-top: 140px;
    padding: 25px;
  }
}

@media (max-width: 600px) {
  .mt-sm-20 {
    margin-top: 155px;
    padding: 25px;
  }
}

@media (max-width: 500px) {
  .mt-sm-20 {
    margin-top: 200px;
    padding: 25px;
  }
}

@media (max-width: 400px) {
  .mt-sm-20 {
    margin-top: 220px;
    padding: 25px;
  }
}
</style>
